import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
    onGetSubscriptionAll,
	onGetSubscriptionByUser
} from "./SubscriptionsThunk";
import { SubscriptionPlan } from "../../domain/entities/SubscriptionPlan";
import { UserSubscription } from "../../domain/entities/UserSubscription";

interface OnboardingState {
	isLoading: boolean;
	isLoadingSubscriptionByUser: boolean;
	hasLoadedSubscriptionsAll: boolean;
	hasLoadedSubscriptionByUser: boolean;
	error?: string;
	subscriptionsAll?: SubscriptionPlan[];
	subscriptionsByUser?: UserSubscription;
}

const initialState: OnboardingState = {
	isLoading: false,
	isLoadingSubscriptionByUser: false,
	hasLoadedSubscriptionsAll: false,
	hasLoadedSubscriptionByUser: false,
	error: undefined,
	subscriptionsAll: undefined,
	subscriptionsByUser: undefined,
};

const subscriptionSlice = createSlice({
	name: "subscriptions",
	initialState,
	reducers: {
		setClearSubscriptionsByUser: (state) => {
				state.subscriptionsByUser = undefined;
		},
		setCancelSubscription: (state) => {
			if (!state.subscriptionsByUser) return;
			state.subscriptionsByUser.status = "CANCELLED";
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(onGetSubscriptionAll.pending, (state) => {
				state.isLoading = true;
			})
			.addCase(
				onGetSubscriptionAll.fulfilled,
				(state, action: PayloadAction<SubscriptionPlan[]>) => {
					state.isLoading = false;
					state.hasLoadedSubscriptionsAll = true;
					state.subscriptionsAll = action.payload;
				}
			)
			.addCase(onGetSubscriptionAll.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoading = false;
				state.hasLoadedSubscriptionsAll = true;
			})
			.addCase(onGetSubscriptionByUser.pending, (state) => {
				state.isLoadingSubscriptionByUser = true;
			})
			.addCase(
				onGetSubscriptionByUser.fulfilled,
				(state, action: PayloadAction<UserSubscription>) => {
					state.isLoadingSubscriptionByUser = false;
					state.hasLoadedSubscriptionByUser = true;
					state.subscriptionsByUser = action.payload;
				}
			)
			.addCase(onGetSubscriptionByUser.rejected, (state, action) => {
				state.error = action.error.message;
				state.isLoadingSubscriptionByUser = false;
				state.hasLoadedSubscriptionByUser = true;
			})
	},
});

export const { setClearSubscriptionsByUser, setCancelSubscription } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
